import React, { useEffect, useRef, useState } from 'react'
import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import '../Styles/style.css';



export default function Header() {

    const [isOpentoggle, setOpentoggle] = useState(false);

    const navigate = useNavigate();

    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);

    const handletoggle = () => {
        setOpentoggle(!isOpentoggle)
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpentoggle]);

    const handleClickOutside = (event) => {
        if (
            isOpentoggle &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)
        ) {
            setOpentoggle(false);
        }
    };

    const location = useLocation();
    const [active, setActive] = useState(location.pathname);

    const menuItems = [
        { name: "ABOUT US", path: "#" },
        { name: "OUR SERVICES", path: "#" },
        { name: "HOW TO GET STARTED", path: "#" },
        { name: "FAQS", path: "#" },
    ];


    return (
        <header>
            <nav className={`flex items-center px-4 py-4 lg:py-5 lg:px-10 font-poppins`}>
                <div className='flex items-center justify-between w-[100%]'>
                    <div className='w-[30%] lg:w-[15%]'>
                        <img onClick={() => { navigate('/') }} src='/assets/logo/Logo.svg'
                            className='block lg:hidden cursor-pointer'
                        ></img>
                    </div>
                    <div className='hidden lg:block lg:w-[70%] text-white uppercase'>
                        <div className='w-full flex justify-evenly items-center gap-10 bg-[#30303075] py-2 rounded realtive'>
                            <a href='#'>About</a>
                            <a href='#'>OUR SERVICES</a>
                            <a className='w-10'></a>
                            <img src='/assets/logo/Logo.svg' className='absolute w-32 -translate-x-5'></img>
                            <a href='#'>HOW TO GET STARTED</a>
                            <a href='#'>FAQS</a>
                        </div>
                    </div>
                    <div className='w-[30%] lg:w-[15%]'>
                        <div className='block lg:hidden'>
                            <div className='flex justify-end pb-2'>
                                <button className='flex flex-col gap-[2px] relative' onClick={handletoggle} ref={buttonRef}>
                                    <div className='w-5 h-[2px] bg-white rounded'></div>
                                    <div className='w-4 h-[2px] bg-white rounded ml-auto'></div>
                                    <div className='w-3 h-[2px] bg-white rounded ml-auto'></div>
                                </button>
                            </div>
                        </div>
                    </div>
                    {isOpentoggle && (
                        <div className='header-drop-down text-black z-10 absolute right-5 mt-2 top-14' ref={dropdownRef}>
                            <div className='flex flex-col gap-2 bg-black text-white text-center rounded-lg border border-white/20 p-5 w-[10rem] uppercase'>
                                {menuItems.map((item) => (
                                    <Link key={item.path} to={item.path} className="group relative" onClick={() => setActive(item.path)}>
                                        <span className={`${active === item.path ? "text-white font-bold" : "text-white/90"}`}>
                                            {item.name}
                                        </span>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </nav>
        </header>
    )
}
